module.exports = __webpack_public_path__ + "static/img/early-settlement-banner.2b77ac4f.png";